import React, { Component } from 'react';
import AiOptionSetWrap from './AiOptionSetWrap';
import AiToolbarWrap from './AiToolbarWrap';
import Sticky  from "react-sticky-el";
//import {Button} from 'primereact/components/button/Button';

export var landscapeReady = false

class RightPanel extends Component {
  componentDidMount() {
      landscapeReady = true
  }

  render() {
    var separate =<AiToolbarWrap className='ai-toolbar-panel'/>
    if (window.testAB==='C' && this.props.initial ==='yes') 
//            rows.push(<div  key="text1" className='ai-text1'><b>{l1}</b><br/><br/>{l2}<br/>{l3}<br/>{l4}<br/>  </div>)
{
     separate=''
}
    return (<div className='ai-right-panel'>
    <Sticky stickyClassName='ai-sticky' topOffset={0} id='stick' 
    positionRecheckInterval={100} disabled={this.props.showSticky}>
    {separate}
    </Sticky>
        <div className='ai-all-options'>
          <AiOptionSetWrap imageSize={this.props.imageSize}  optionNumber={this.props.optionNumber} optionSize={this.props.optionSize} orientation={this.props.orientation}/>     
 
        </div>
        
      </div>
    );
  }
}

export default RightPanel;


// WEBPACK FOOTER //
// ./src/layout/RightPanel.js